import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/Signup';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import DrillLogList from './components/DrillLogList';
import DrillLogDetail from './components/DrillLogDetail';
import BoreholeList from './components/BoreholeList';
import BoreholeDetailWrapper from './components/BoreholeDetailWrapper';
import UploadPage from './components/UploadPage';
import SeismicDesignSupportContainer from './components/SeismicDesignSupportContainer';
import GroundResponseDetailPage from './components/seismic/GroundResponseDetailPage';
import UserManagementPage from './components/UserManagementPage';
import { useAuth } from './contexts/AuthContext';

// Toast 컴포넌트를 별도로 분리
function ToastNotification({ message, isVisible }) {
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 animate-slide-up">
      <div className="bg-white rounded-xl shadow-hard px-6 py-4 flex items-center space-x-3">
        <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
          <svg className="w-3 h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-sm font-medium text-secondary-900">{message}</p>
      </div>
    </div>
  );
}

// 메인 레이아웃 컴포넌트
function MainLayout() {
  const location = useLocation();
  const [toastMessage, setToastMessage] = useState('');
  const [isToastVisible, setIsToastVisible] = useState(false);

  // Toast 표시 함수
  const showToast = (message) => {
    setToastMessage(message);
    setIsToastVisible(true);
    setTimeout(() => {
      setIsToastVisible(false);
    }, 3000);
  };

  return (
    <div className="h-screen flex flex-col bg-secondary-50">
      <Header />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<UploadPage showToast={showToast} />} />
          <Route path="/drill-logs" element={<DrillLogList />} />
          <Route path="/drill-logs/:id" element={<DrillLogDetail showToast={showToast} />} />
          <Route path="/boreholes" element={<BoreholeList />} />
          <Route path="/boreholes/:id" element={<BoreholeDetailWrapper showToast={showToast} />} />
          <Route path="/seismic" element={<SeismicDesignSupportContainer showToast={showToast} />} />
          <Route path="/seismic/detail/:boreholeId" element={<GroundResponseDetailPage />} />
          <Route path="/users" element={<UserManagementPage showToast={showToast} />} />
        </Routes>
      </div>
      <ToastNotification message={toastMessage} isVisible={isToastVisible} />
    </div>
  );
}

function App() {
  const { user, loading } = useAuth();

  // 로딩 중
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-secondary-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* 로그인하지 않은 경우 */}
        {!user ? (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          /* 로그인한 경우 */
          <>
            <Route path="/*" element={<MainLayout />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/signup" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
